import React from 'react';
import ReactDraggable from 'react-draggable';

interface SafeDraggableProps {
  handle?: string;
  bounds?: string | object;
  nodeRef?: React.RefObject<HTMLElement>;
  children: React.ReactNode;
}

/** Thin wrapper — avoids strict TS mismatch with react-draggable prop types. */
const SafeDraggable: React.FC<SafeDraggableProps> = (props) => {
  const Draggable = ReactDraggable as unknown as React.ComponentType<SafeDraggableProps>;
  return <Draggable {...props} />;
};

export default SafeDraggable;
